import React from 'react';

import type { FacebookStoryComponentsProps } from './types';

export function Header(_props: FacebookStoryComponentsProps): React.JSX.Element {
	return <div>Facebook Story Header</div>;
}
